import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import Alert from 'component/Alert'
import Badge from 'component/Badge'
import Checkbox from 'component/Checkbox/newCheckbox'
import Radio from 'component/Radio'
import RadioGroup from 'component/RadioGroup'
import Switch from 'component/Switch'
import CounterInput from 'component/CounterInput'
import Modal from 'component/Modal/GenericModal'
import Button from 'component/Button'
import TextField from 'component/TextField'
import SearchInput from 'component/SearchInput'
import PasswordInput from 'component/PasswordInput'
import TextArea from 'component/TextArea'
import FileInput from 'component/FileInput'

import infoIcon from 'images/filter-icon.svg'
import Select from 'component/Select/Select'
import AutoCompleteInput from 'component/AutoCompleteInput/AutoCompleteInput'
import DateIntervalInput from 'component/DateIntervalInput/DateIntervalInput'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Card from 'component/utils/Card'
import { NavTab, Tab } from 'component/NavTab'

import Accordion from 'component/utils/Accordion'
import Glyph from 'component/utils/Glyph'
import Editor from 'component/HtmlEditor'
import TextLink from 'component/TextLink'
import ContentHeader from 'component/utils/ContentHeader'

import Download from 'images/download_green.svg'
import DownloadDisabled from 'images/download_disabled.svg'
import DownloadDanger from 'images/download_danger.svg'
import SuccessModal from 'component/Modal/SuccessModal'
import ArrowUpGreen from '../../components/ArrowUp'
import ArrownDownRed from '../../components/ArrowDown'
import MyResponsivePie from '../../components/pieBar'
import data from '../../components/pieBar/data'

import TextFieldVersion2 from 'component/TextFieldVersion2'
import ButtonVersion2 from 'component/ButtonVersion2'
import DefaultIcon from '../../../images/update-icon.svg';

class ComponentShowCase extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.setMaxDate = this.setMaxDate.bind(this)
    this.setMinDate = this.setMinDate.bind(this)
  }

  state = {
    successModal: false,
    data,
    loops: 0,
    maxDate: null,
    minDate: null,
    maxDays: 5,
    loopInterval: null
  }


  setMaxDate(maxDate) {
    let maxDays = parseInt(this.state.maxDays.toString(), 10)
    if(!maxDays) {
      maxDays = 5
    }

    let increaseDate;

    if(maxDate) {
      increaseDate = maxDate.add(maxDays - 1, 'days').toDate()
      this.setState({maxDate: increaseDate})
    }
    else {

    this.setState({maxDate})
    }
  }

  setMinDate(minDate) {
    this.setState({minDate})
  }

  showPieBarUpdating() {
       const loop = setInterval(() => {
         this.setState({loops: this.state.loops + 1})
         this.updatePieBar()
       }, 500)

       this.setState({loopInterval: loop})
  }

  updatePieBar() {

    const pieBars = [...this.state.data]

    if(pieBars[0].value !== 100 && pieBars[1].value !== 0) {
    pieBars[0].value += 5
    pieBars[1].value -= 5
    this.setState({data: pieBars})
    }

    else {
      clearInterval(this.state.loopInterval)
      this.setState({loopInterval: null})
      this.setState({loops: 0})
      pieBars[0].value = 0
      pieBars[1].value = 100
      this.setState({data: pieBars})
    }

  }

  render() {
    const { translate } = this.props
    const { successModal } = this.state

    return (
      <>
        <ContentHeader>{translate('component.showcase')}</ContentHeader>

        {successModal && (
          <SuccessModal
            size='sm'
            handleClose={() => this.setState({ successModal: false })}
            t={translate}
            center
            msg='Texto de sucesso'
          />
        )}

        <div className='main-show-case-container'>
          <div className='show-case'>
            <h4>Modal</h4>
            <Modal
              title='Título do Modal'
              size='sm'
              buttonText='Abrir modal pequeno'
              onCloseModal={() => console.log('MODAL FECHADO')}
              onConfirm={() => console.log('MODAL CONFIRMADO')}
              onOpenModal={() => console.log('MODAL ABERTO')}
            >
              <div>
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno Conteúdo do modal pequeno Conteúdo do
                modal pequeno Conteúdo do modal pequeno Conteúdo do modal
                pequeno Conteúdo do modal pequeno Conteúdo do modal pequeno
                Conteúdo do modal pequeno
              </div>
            </Modal>
            <Modal
              title='Título do Modal'
              size='md'
              buttonText='Abrir modal médio'
            >
              <div>
                Conteúdo do modal médio Conteúdo do modal médio Conteúdo do
                modal médio Conteúdo do modal médio Conteúdo do modal médio
                Conteúdo do modal médio Conteúdo do modal médio Conteúdo do
                modal médio Conteúdo do modal médio
              </div>
            </Modal>
            <Modal
              title='Título do Modal'
              size='lg'
              buttonText='Abrir modal grande'
            >
              <div>
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande Conteúdo do
                modal grande Conteúdo do modal grande Conteúdo do modal grande
                Conteúdo do modal grande Conteúdo do modal grande
              </div>
            </Modal>
            <Button
              className='open-modal-button'
              text='Abrir modal de sucesso'
              onClick={() => this.setState({ successModal: true })}
            />
          </div>

          <div className='show-case'>
            <h4>AutoCompleteInput</h4>
            <Row>
              <Col md={6}>
                <AutoCompleteInput
                  label='Digite o nome da cidade'
                  helpText='Sou um texto de ajuda'
                  placeholder='Digite o nome da sua cidade'
                  successText='Cidade válida'
                  errorText='Digite uma cidade válida'
                  warningText='Campo obrigatório'
                  required
                  validateValue={(value) => value}
                  getAutocompleteOptions={(text, callback) => {
                    setTimeout(() => {
                      callback(
                        [
                          'São Paulo',
                          'Brasília',
                          'Caxias do Sul',
                          'Pelotas',
                        ].filter(
                          (opt) =>
                            (opt || '')
                              .toLowerCase()
                              .indexOf((text || '').toLowerCase()) === 0
                        )
                      )
                    }, 1000)
                  }}
                />
              </Col>
              <Col md={6}>
                <AutoCompleteInput
                  label='Loja'
                  helpText='Assim fica mais facil te enviarmos ofertas'
                  placeholder='Selecione sua loja favorita'
                  successText='A loja é valida'
                  errorText='A loja não é valida'
                  warningText='Campo obrigatório'
                  disabled
                  validateValue={(value) => !!value}
                  getAutocompleteOptions={(text, callback) => {
                    setTimeout(() => {
                      callback(
                        ['São Paulo', 'Brasília', 'Caxias do Sul'].filter(
                          (opt) =>
                            (opt || '')
                              .toLowerCase()
                              .indexOf((text || '').toLowerCase()) === 0
                        )
                      )
                    }, 1100)
                  }}
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Selects</h4>
            <Row>
              <Col md={3}>
                <Select
                  label='Loja'
                  helpText='Assim fica mais facil te enviarmos ofertas'
                  placeholder='Selecione sua loja favorita'
                  successText='A loja é valida'
                  errorText='A loja não é valida'
                  warningText='Campo obrigatório'
                  required
                  validateValue={(value) => !!value}
                  options={[
                    { value: 1, label: 'teste1' },
                    { value: 2, label: 'teste2' },
                    { value: 3, label: 'teste3' },
                    { value: 4, label: 'teste4' },
                  ]}
                />
              </Col>
              <Col md={3}>
                <Select
                  label='Loja'
                  helpText='Assim fica mais facil te enviarmos ofertas'
                  placeholder='Selecione sua loja favorita'
                  successText='A loja é valida'
                  errorText='A loja não é valida'
                  warningText='Campo obrigatório'
                  disabled
                  validateValue={(value) => !!value}
                  options={[
                    { value: 1, label: 'teste1' },
                    { value: 2, label: 'teste2' },
                    { value: 3, label: 'teste3' },
                    { value: 4, label: 'teste4' },
                  ]}
                />
              </Col>
              <Col md={3}>
                <Select
                  label='Loja'
                  helpText='Assim fica mais facil te enviarmos ofertas'
                  placeholder='Selecione sua loja favorita'
                  successText='A loja é valida'
                  errorText='A loja não é valida'
                  warningText='Campo obrigatório'
                  required
                  validateValue={(value) => !!value && value.length > 0}
                  options={[
                    { value: 1, label: 'teste1' },
                    { value: 2, label: 'teste2' },
                    { value: 3, label: 'teste3' },
                    { value: 4, label: 'teste4' },
                    { value: 5, label: 'teste5' },
                    { value: 6, label: 'teste6' },
                  ]}
                  isMulti
                />
              </Col>
              <Col md={3}>
                <Select
                  label='Loja'
                  helpText='Agrupando itens selecionados'
                  placeholder='Selecione sua loja favorita'
                  successText='A loja é valida'
                  errorText='A loja não é valida'
                  warningText='Campo obrigatório'
                  required
                  groupOptions
                  selectAll
                  validateValue={(value) => !!value && value.length > 0}
                  options={[
                    { value: 1, label: 'teste1' },
                    { value: 2, label: 'teste2' },
                    { value: 3, label: 'teste3' },
                    { value: 4, label: 'teste4' },
                    { value: 5, label: 'teste5' },
                    { value: 6, label: 'teste6' },
                  ]}
                  isMulti
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Data</h4>
            <Row>
              <Col xs={3}>
                <DateIntervalInput label='Data' onChange={console.log} />
              </Col>
              <Col xs={3}>
                <DateIntervalInput
                  label='Data sem seleção'
                  required
                  noSelect
                  onChange={console.log}
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>

          <h4>Novo componente de calendário </h4>
            <Row>
              <Col xs={3}>
              <TextField
                  label='Digite o período máximo em dias, padrão ou input inválido = 5'
                  d
                  type="number"
                  required
                  onChange={(e) => this.setState({maxDays: e.target.value})}
                  helpText='Dias'
                  validateValue={() => {

                    if (this.state.maxDays && this.state.maxDays.toString().replace(/\D/g, ' ').length > 0) {
                      return true
                    }
                    return false
                  }}
                />
              </Col>
              <Col xs={3}>
                <NewDateIntervalInput
                  user={this.props.auth.user}
                  maxRange={this.state.maxDays}
                  label='Data com restrição'
                  required
                  noSelect
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>FileInput</h4>
            <Row>
              <Col md={6}>
                <FileInput
                  label='Texto'
                  required
                  successText='O texto é válido'
                  errorText='Arquivo inválido'
                  helpText='Selecione uma imagem .jpg'
                  accept='.jpg'
                />
              </Col>
              <Col md={6}>
                <FileInput label='Texto' readOnly />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FileInput label='Texto' disabled />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>TextArea</h4>
            <Row>
              <Col md={6}>
                <TextArea
                  label='Texto'
                  required
                  placeholder='Digite...'
                  successText='O texto é válido'
                  errorText='Texto grande demais'
                  helpText='O texto deve ter no máximo 100 caracteres.'
                  validateValue={(value) => {
                    if (value && value.length <= 100) {
                      return true
                    }
                    return false
                  }}
                />
              </Col>
              <Col md={6}>
                <TextArea
                  label='Texto'
                  placeholder='placeholder'
                  readOnly
                  value='João da Silva'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextArea label='Texto' value='João da Silva' disabled />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>PasswordInput</h4>
            <Row>
              <Col md={6}>
                <PasswordInput
                  label='Senha'
                  placeholder='Digite seu nome'
                  successText='Senha válida'
                  errorText='A senha deve conter o número 1'
                  helpText='Digite a sua senha'
                  validateValue={(value) => {
                    if (value && value.includes('1')) {
                      return true
                    }
                    return false
                  }}
                />
              </Col>
              <Col md={6}>
                <PasswordInput
                  label='Senha'
                  placeholder='placeholder'
                  readOnly
                  value='João da Silva'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <PasswordInput label='Senha' value='João da Silva' disabled />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>SearchInput</h4>
            <Row>
              <Col md={6}>
                <SearchInput
                  label='Nome completo'
                  placeholder='Placeholder'
                  validateValue={(value) => {
                    if ((value && value.length <= 6) || !value) {
                      return false
                    }
                    return true
                  }}
                />
              </Col>
              <Col md={6}>
                <SearchInput
                  label='Ano'
                  d
                  helpText='Digitre o seu nome'
                  warningText='Digite apenas números'
                  validateValue={(value) => {
                    if (value && value.replace(/\D/g, ' ').length > 0) {
                      return true
                    }
                    return false
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <SearchInput
                  label='Nome completo'
                  placeholder='placeholder'
                  readOnly
                  value='João da Silva'
                />
              </Col>
              <Col md={6}>
                <SearchInput
                  label='Nome completo'
                  value='João da Silva'
                  disabled
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>TextField</h4>
            <Row>
              <Col md={6}>
                <TextField
                  label='Nome completo'
                  helpText='Deve ter no mínimo 5 digitos'
                  successText='O nome é válido'
                  errorText='Nome não é válido'
                  warningText='Campo obrigatório'
                  required
                  validateValue={(value) => {
                    if ((value && value.length <= 5) || !value) {
                      return false
                    }
                    return true
                  }}
                />
              </Col>
              <Col md={6}>
                <TextField
                  label='Ano'
                  d
                  helpText='Digitre o seu nome'
                  warningText='Digite apenas números'
                  required
                  validateValue={(value) => {
                    if (value && value.replace(/\D/g, '').length > 0) {
                      return true
                    }
                    return false
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextField
                  label='Nome completo'
                  placeholder='Digite seu nome'
                />
              </Col>
              <Col md={6}>
                <TextField
                  label='Nome completo'
                  placeholder='placeholder'
                  readOnly
                  value='João da Silva'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextField
                  label='Nome completo'
                  value='João da Silva'
                  disabled
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>TextField Versão 2.0</h4>
            <Row>
              <Col md={6}>
                <TextFieldVersion2
                  label='Nome completo'
                  helpText='Deve ter no mínimo 5 digitos'
                  errorText='Nome não é válido'
                  warningText='Campo obrigatório'
                  required
                  validateValue={(value) => {
                    if ((value && value.length <= 5) || !value) {
                      return false
                    }
                    return true
                  }}
                />
              </Col>
              <Col md={6}>
                <TextFieldVersion2
                  label='Ano'
                  helpText='Digite o seu nome'
                  warningText='Digite apenas números'
                  required
                  validateValue={(value) => {
                    if (value && value.replace(/\D/g, '').length > 0) {
                      return true
                    }
                    return false
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextFieldVersion2
                  label='Nome completo com ícone'
                  required
                  validateValue={(value) => {
                    if ((value && value.length <= 5) || !value) {
                      return false
                    }
                    return true
                  }}
                  hasLeading={true}
                />
              </Col>
              <Col md={6}>
                <TextFieldVersion2
                  label='Processando...'
                  required
                  validateValue={(value) => {
                    if (value && value.replace(/\D/g, '').length > 0) {
                      return true
                    }
                    return false
                  }}
                  showProcessing={true}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextFieldVersion2
                  label='Nome completo'
                  placeholder='Digite seu nome'
                />
              </Col>
              <Col md={6}>
                <TextFieldVersion2
                  label='Nome completo'
                  placeholder='placeholder'
                  readOnly
                  value='João da Silva'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <TextFieldVersion2
                  label='Nome completo'
                  value='João da Silva'
                  disabled
                />
              </Col>
              <Col md={6}>
                <TextFieldVersion2
                  label='Input com Action'
                  required
                  helpText='Clique ao lado para ação'
                  hasButton={true}
                />
              </Col>
            </Row>

            <p>Última atualização: 31/07/2024</p>
            <p>Fonte:<a href="https://www.figma.com/design/tTgmRN97Ye5uzNGAB3ITUt/Documentac%CC%A7a%CC%83o-DS?node-id=1376-15330&t=UnrNs4SCE9fWRL4O-0"> Link do Figma</a>  </p>
          </div>

          <div className='show-case'>
            <h4>CounterInput</h4>
            <Row>
              <Col md={3}>
                <CounterInput
                  name='counter-1'
                  label='Contador'
                  helpText='Selecione um valor'
                  value={9}
                  maxValue={10}
                  validateValue={(value) => {
                    if (value === 10 || value === 8) {
                      return false
                    }
                    return true
                  }}
                  errorText='Não é valido'
                />
              </Col>
              <Col md={3}>
                <CounterInput
                  name='counter-2'
                  label='Estou desativado'
                  disabled
                />
              </Col>
              <Col md={3}>
                <CounterInput
                  name='counter-3'
                  label='Contador'
                  successText='Valor válido'
                  helpText='Selecione um valor'
                  value={8}
                  isValid={false}
                  errorText='Alguma coisa está errada'
                />
              </Col>
              <Col md={3}>
                <CounterInput
                  name='counter-4'
                  label='Eu sou valido'
                  helpText='Selecione um valor'
                  value={10}
                  maxValue={10}
                  minValue={0}
                  successText='é valido'
                />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Button</h4>
            <Row>
              <Button
                className='btn-sm btn-primary margin-right'
                text='Primary'
                icon={infoIcon}
              />
              <Button
                className='btn-sm btn-secondary margin-right'
                text='Secondary'
              />
              <Button
                className='btn-sm btn-primary margin-right'
                disabled
                text='Primary disabled'
              />
              <Button
                className='btn-sm btn-secondary'
                disabled
                text='Secondary disabled'
              />
            </Row>
            <Row className='margin-top-small'>
              <Button className='btn btn-primary margin-right' text='Primary' />
              <Button
                className='btn btn-secondary margin-right'
                text='Secondary'
              />
              <Button
                className='btn btn-primary margin-right'
                disabled
                text='Primary disabled'
              />
              <Button
                className='btn btn-secondary'
                disabled
                text='Secondary disabled'
              />
            </Row>
            <Row className='margin-top-small'>
              <Button
                className='btn-lg btn-primary margin-right'
                text='Primary'
              />
              <Button
                className='btn-lg btn-secondary margin-right'
                text='Secondary'
              />
              <Button
                className='btn-lg btn-primary margin-right'
                disabled
                text='Primary disabled'
              />
              <Button
                className='btn-lg btn-secondary'
                disabled
                text='Secondary disabled'
              />
            </Row>
            <Row className='margin-top-small'>
              <Button
                className='btn-lg btn-danger margin-right'
                text='Primary'
              />
              <Button
                className='btn-lg btn-danger-outline margin-right'
                text='Secondary'
              />
              <Button
                className='btn-lg btn-danger margin-right'
                disabled
                text='Primary disabled'
              />
              <Button
                className='btn-lg btn-danger-outline'
                disabled
                text='Secondary disabled'
              />
            </Row>
          </div>

          <div className='show-case'>
            <h4>Button Version 2.0</h4>
            <Row>
              <p>Size</p>
              <ButtonVersion2
                size="sm"
                color="default"
                role="primary"
                text="Small"
              />
              <ButtonVersion2
                size="md"
                color="default"
                role="primary"
                text="Medium"
              />
              <ButtonVersion2
                size="lg"
                color="default"
                role="primary"
                text="Large"
              />
            </Row>

            <Row className='margin-top-small'>
              <p>Primary</p>
              <ButtonVersion2
                color="default"
                role="primary"
                text="Default"
              />
              <ButtonVersion2
                color="info"
                role="primary"
                text="Info"
              />
              <ButtonVersion2
                color="success"
                role="primary"
                text="Success"
              />
               <ButtonVersion2
                color="warning"
                role="primary"
                text="Warning"
              />
               <ButtonVersion2
                color="danger"
                role="primary"
                text="Danger"
              />
            </Row>

            <Row className='margin-top-small'>
              <p>Secondary</p>
              <ButtonVersion2
                color="default"
                role="secondary"
                text="Default"
              />
              <ButtonVersion2
                color="info"
                role="secondary"
                text="Info"
              />
              <ButtonVersion2
                color="success"
                role="secondary"
                text="Success"
              />
               <ButtonVersion2
                color="warning"
                role="secondary"
                text="Warning"
              />
               <ButtonVersion2
                color="danger"
                role="secondary"
                text="Danger"
              />
            </Row>

            <Row className='margin-top-small'>
              <p>Subtle</p>
              <ButtonVersion2
                color="default"
                role="subtle"
                text="Default Subtle"
              />
              <ButtonVersion2
                color="info"
                role="subtle"
                text="Info"
              />
              <ButtonVersion2
                color="success"
                role="subtle"
                text="Success"
              />
               <ButtonVersion2
                color="warning"
                role="subtle"
                text="Warning"
              />
               <ButtonVersion2
                color="danger"
                role="subtle"
                text="Danger"
              />
            </Row>

            <Row className='margin-top-small'>
              <p>With Left Icon</p>
              <ButtonVersion2
                iconLeft={true}
                iconUrl={DefaultIcon}
                text="Left Icon"
                size="md"
              />
            </Row>

            <Row className='margin-top-small'>
              <p>With Right Icon</p>
             <ButtonVersion2
                iconRight={true}
                iconUrl={DefaultIcon}
                text="Right Icon"
                size="md"
              />
            </Row>

            <Row className='margin-top-small'>
              <p>Disabled</p>
              <ButtonVersion2
                disabled
                text="Disabled"
                size="md"
              />
            </Row>

            <p>Última atualização: 31/07/2024</p>
            <p>Fonte:<a href="https://www.figma.com/design/tTgmRN97Ye5uzNGAB3ITUt/Documentac%CC%A7a%CC%83o-DS?node-id=1376-15330&t=UnrNs4SCE9fWRL4O-0"> Link do Figma</a> </p>
          </div>

          <div className='show-case'>
            <h4>Badge</h4>

            <Row>
              <Badge text='Erro' badgeType='error' />
              <Badge text='Sucesso' badgeType='success' />
              <Badge text='Padrão' badgeType='primary' />
              <Badge text='Padrão' badgeType='secondary' />
              <Badge text='Cuidado' badgeType='warning' />
              <Badge text='Erro' badgeType='error-light' />
              <Badge text='Sucesso' badgeType='success-light' />
              <Badge text='Padrão' badgeType='primary-light' />
              <Badge text='Padrão' badgeType='secondary-light' />
              <Badge text='Cuidado' badgeType='warning-light' />
            </Row>

            <Row>
              <Badge text='+5' badgeType='error' />
              <Badge text='+5' badgeType='success' />
              <Badge text='+5' badgeType='primary' />
              <Badge text='+5' badgeType='secondary' />
              <Badge text='+5' badgeType='warning' />
              <Badge text='+5' badgeType='error-light' />
              <Badge text='+5' badgeType='success-light' />
              <Badge text='+5' badgeType='primary-light' />
              <Badge text='+5' badgeType='secondary-light' />
              <Badge text='+5' badgeType='warning-light' />
            </Row>

            <Row>
              <Badge text='Um texto um pouco mais extenso' badgeType='error' />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='success'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='primary'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='secondary'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='warning'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='error-light'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='success-light'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='primary-light'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='secondary-light'
              />
              <Badge
                text='Um texto um pouco mais extenso'
                badgeType='warning-light'
              />
            </Row>
          </div>

          <div className='show-case'>
            <h4>Checkbox</h4>

            <Row>
              <Col md={6}>
                <p>Checkbox separados</p>
                <Checkbox name='checkbox1' label='Cheque aqui' required />
                <Checkbox name='checkbox2' label='Estou desativado' disabled />
              </Col>
              <Col md={6}>
                <p>Grupo de checkbox</p>
                <div className='checkbox-group'>
                  <Checkbox name='checkbox3' label='Cheque aqui 1' />
                  <Checkbox name='checkbox4' label='Cheque aqui 2' />
                  <Checkbox name='checkbox5' label='Cheque aqui 3' />
                  <Checkbox name='checkbox6' label='Cheque aqui 4' />
                  <Checkbox
                    name='checkbox7'
                    label='Estou desativado'
                    disabled
                  />
                  <Checkbox
                    name='checkbox8'
                    label='Estou desativado'
                    disabled
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Radio</h4>

            <Row>
              <Col md={6}>
                <p>Radio separados</p>
                <Radio name='radio1' label='Cheque aqui' />
                <Radio name='radio2' label='Estou desativado' disabled />
              </Col>
              <Col md={6}>
                <p>Grupo de Radio</p>
                <RadioGroup label='Um grupo de inputs' className='radio-group'>
                  <Radio name='radio' id='radio3' label='Cheque aqui 1' />
                  <Radio name='radio' id='radio4' label='Cheque aqui 2' />
                  <Radio name='radio' id='radio5' label='Cheque aqui 3' />
                  <Radio name='radio' id='radio6' label='Cheque aqui 4' />
                  <Radio
                    name='radio'
                    id='radio7'
                    label='Estou desativado'
                    disabled
                  />
                  <Radio
                    name='radio'
                    id='radio8'
                    label='Estou desativado'
                    disabled
                  />
                </RadioGroup>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Toggle/Switch</h4>
            <Row>
              <Col md={4}>
                <Switch name='switch1' label='Cheque aqui' />
              </Col>
              <Col md={4}>
                <Switch name='switch3' label='Cheque aqui' />
              </Col>
              <Col md={4}>
                <Switch name='switch2' label='Estou desativado' disabled />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Alerts</h4>
            <Alert
              alertType='error'
              text='Foi isso que aconteceu agora ou vai acontecer agora ou vai acontecer '
              actionName='Teste'
              onConfirm={() => alert('Você clicou em TESTE')}
            />
            <Alert
              alertType='success'
              text='Foi isso que aconteceu agora ou vai acontecer ou ainda está acontecendo nesse momento, por favor atenção Foi isso que aconteceu agora ou vai acontecer ou ainda está acontecendo nesse momento, por favor atenção'
            />
            <Alert
              alertType='warning'
              text='Foi isso que aconteceu agora ou vai acontecer ou ainda está acontecendo nesse momento, por favor atenção'
            />
            <Alert
              alertType='default'
              text='Foi isso que aconteceu agora ou vai acontecer ou ainda está acontecendo nesse momento, por favor atenção'
            />
          </div>

          <div className='show-case'>
            <h4>Compact Table</h4>
            <Row>
              <Col xs={6}>
                <table className='table-compact'>
                  <thead>
                    <tr>
                      <th>Seções</th>
                      <th className='align-center'>Qtde. de ocorrências</th>
                      <th className='align-center'>Porcentagem</th>
                      <th className='align-center'>Tratados</th>
                      <th className='align-center'>Porcentagem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1 - Materiais</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>2 - CARPINTARIA E MADEIRA</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>3 - ELETRICIDADE</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>4 - FERRAMENTAS</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>5 - PISOS LAMINADOS E VINILICOS</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>6 - CERÂMICA</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>7 - SANITÁRIO</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                    <tr>
                      <td>13 - ILUMINAÇÃO</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>11,11%</td>
                      <td className='align-center'>01</td>
                      <td className='align-center'>100%</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Accordion</h4>
            <Row>
              <Col xs={6}>
                <Accordion
                  title='Teste'
                  onChange={(e) =>
                    console.log(`Accordion ${e ? 'open' : 'closed'}`)
                  }
                >
                  <p style={{ margin: 0 }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aenean et malesuada lorem, et pharetra nunc. Integer at
                    libero urna. Nulla cursus quis dui vel faucibus.
                  </p>
                </Accordion>
                <Accordion title='Default aberto' active className='margin-top'>
                  <p style={{ margin: 0 }}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aenean et malesuada lorem, et pharetra nunc. Integer at
                    libero urna. Nulla cursus quis dui vel faucibus.
                  </p>
                </Accordion>

                <Accordion
                  title={
                    <table className='table-compact text-uppercase'>
                      <tbody>
                        <tr />
                        <tr>
                          <td width='40%'>0001 - Loja Interlagos</td>
                          <td width='15%' className='align-center'>
                            03
                          </td>
                          <td width='15%' className='align-center'>
                            33,33%
                          </td>
                          <td width='15%' className='align-center'>
                            02
                          </td>
                          <td width='15%' className='align-center'>
                            66,66%
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }
                  className='margin-top'
                >
                  <table className='table-compact text-uppercase'>
                    <tbody>
                      <tr>
                        <td width='40%'>1 - Materiais</td>
                        <td width='15%' className='align-center'>
                          01
                        </td>
                        <td width='15%' className='align-center'>
                          33,33%
                        </td>
                        <td width='15%' className='align-center'>
                          02
                        </td>
                        <td width='15%' className='align-center'>
                          50%
                        </td>
                      </tr>
                      <tr>
                        <td>2 - Carpintaria e madeira</td>
                        <td className='align-center'>01</td>
                        <td className='align-center'>33,33%</td>
                        <td className='align-center'>02</td>
                        <td className='align-center'>50%</td>
                      </tr>
                      <tr>
                        <td>3 - Eletricidade</td>
                        <td className='align-center'>01</td>
                        <td className='align-center'>33,33%</td>
                        <td className='align-center'>02</td>
                        <td className='align-center'>50%</td>
                      </tr>
                    </tbody>
                  </table>
                </Accordion>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Cards</h4>
            <Row>
              <Col xs={3}>
                <Card title='CARD COM TÍTULO'>
                  <p>
                    Proin vulputate mi at euismod fringilla. Proin fermentum,
                    leo eget rhoncus tincidunt, enim urna placerat sapien, ac
                    accumsan mauris nisl non justo.
                  </p>
                </Card>
              </Col>
              <Col xs={3}>
                <Card>
                  <p>Card sem título</p>
                  <p>
                    Nullam venenatis finibus interdum. Curabitur fringilla felis
                    ligula, vel egestas justo varius et.{' '}
                  </p>
                </Card>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>NavTab</h4>
            <Row>
              <Col xs={6}>
                <NavTab
                  defaultTab={1}
                  onChange={(e) => {
                    console.log(`Tab ${e}`)
                  }}
                >
                  <Tab title='Tab 1'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Vestibulum egestas, lacus at blandit lacinia, tellus purus
                      tincidunt velit, in tincidunt orci odio nec nulla. Aliquam
                      sed ultricies ligula, a eleifend ipsum. Class aptent
                      taciti sociosqu ad litora torquent per conubia nostra, per
                      inceptos himenaeos. Mauris ac mattis leo.
                    </div>
                  </Tab>
                  <Tab title='Tab 2'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Sed a sem ac sem molestie auctor a eu augue. Pellentesque
                      blandit metus sed vulputate consequat. Proin sit amet
                      faucibus dolor, ut eleifend nulla. Curabitur ex tortor,
                      faucibus eget cursus quis, scelerisque in enim. Integer
                      quis erat eu ex condimentum sollicitudin. Suspendisse
                      pretium molestie risus suscipit dapibus. Integer elementum
                      eleifend velit vitae pellentesque.
                    </div>
                  </Tab>
                  <Tab title='Testando'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Ut vel nisl in nunc convallis fringilla. Proin eget nibh
                      diam. Quisque et quam condimentum mauris accumsan vehicula
                      sed in neque. Sed magna arcu, eleifend eu enim a, porta
                      convallis arcu. Sed interdum accumsan vestibulum. Nullam
                      sit amet elit libero. Nunc luctus mauris quis faucibus
                      aliquet.
                    </div>
                  </Tab>
                </NavTab>
              </Col>
              <Col xs={6}>
                <NavTab
                  onChange={(e) => {
                    console.log(`Tab ${e}`)
                  }}
                >
                  <Tab
                    title={
                      <>
                        <i className='glyph glyph-clock' />
                        &nbsp;&nbsp;Tab 1
                      </>
                    }
                  >
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Vestibulum egestas, lacus at blandit lacinia, tellus purus
                      tincidunt velit, in tincidunt orci odio nec nulla. Aliquam
                      sed ultricies ligula, a eleifend ipsum. Class aptent
                      taciti sociosqu ad litora torquent per conubia nostra, per
                      inceptos himenaeos. Mauris ac mattis leo.
                    </div>
                  </Tab>
                  <Tab
                    title={
                      <>
                        <i className='glyph glyph-tag' />
                        &nbsp;&nbsp;Tab 2
                      </>
                    }
                  >
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Sed a sem ac sem molestie auctor a eu augue. Pellentesque
                      blandit metus sed vulputate consequat. Proin sit amet
                      faucibus dolor, ut eleifend nulla. Curabitur ex tortor,
                      faucibus eget cursus quis, scelerisque in enim. Integer
                      quis erat eu ex condimentum sollicitudin. Suspendisse
                      pretium molestie risus suscipit dapibus. Integer elementum
                      eleifend velit vitae pellentesque.
                    </div>
                  </Tab>
                  <Tab title='Testando'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Ut vel nisl in nunc convallis fringilla. Proin eget nibh
                      diam. Quisque et quam condimentum mauris accumsan vehicula
                      sed in neque. Sed magna arcu, eleifend eu enim a, porta
                      convallis arcu. Sed interdum accumsan vestibulum. Nullam
                      sit amet elit libero. Nunc luctus mauris quis faucibus
                      aliquet.
                    </div>
                  </Tab>
                  <Tab title='Tab 4'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Vestibulum egestas, lacus at blandit lacinia, tellus purus
                      tincidunt velit, in tincidunt orci odio nec nulla. Aliquam
                      sed ultricies ligula, a eleifend ipsum. Class aptent
                      taciti sociosqu ad litora torquent per conubia nostra, per
                      inceptos himenaeos. Mauris ac mattis leo.
                    </div>
                  </Tab>
                  <Tab title='Tab 5'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Sed a sem ac sem molestie auctor a eu augue. Pellentesque
                      blandit metus sed vulputate consequat. Proin sit amet
                      faucibus dolor, ut eleifend nulla. Curabitur ex tortor,
                      faucibus eget cursus quis, scelerisque in enim. Integer
                      quis erat eu ex condimentum sollicitudin. Suspendisse
                      pretium molestie risus suscipit dapibus. Integer elementum
                      eleifend velit vitae pellentesque.
                    </div>
                  </Tab>
                  <Tab title='Tab 6'>
                    <div style={{ textAlign: 'justify', lineHeight: '28px' }}>
                      Ut vel nisl in nunc convallis fringilla. Proin eget nibh
                      diam. Quisque et quam condimentum mauris accumsan vehicula
                      sed in neque. Sed magna arcu, eleifend eu enim a, porta
                      convallis arcu. Sed interdum accumsan vestibulum. Nullam
                      sit amet elit libero. Nunc luctus mauris quis faucibus
                      aliquet.
                    </div>
                  </Tab>
                </NavTab>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Ícones</h4>
            <Row>
              <Col xs={2}>
                <p>Ícones habilitados</p>
                <Row className='glyphs-showcase'>
                  <img
                    src={Download}
                    className='cursor-pointer'
                    width={48}
                    height={48}
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='arrow-left'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='arrow-right'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='calendar'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='camera'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='cart'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='chat-balloon'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='checked'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='clock'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='clone'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='dollar-sign'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-down'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-left'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-right'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-up'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='envelope'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='exclamation-mark'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='external'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='eye'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='heart'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='location'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='magnifier'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='order'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='pencil'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='printer'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='question-mark'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='refresh'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='settings'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='silhouette'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='tag'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='tools'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='trash-can'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='verified-price'
                    color='primary'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='x'
                    color='primary'
                  />
                </Row>
              </Col>
              <Col xs={2}>
                <p>Ícones com danger</p>
                <Row className='glyphs-showcase'>
                  <img
                    src={DownloadDanger}
                    className='cursor-pointer'
                    width={48}
                    height={48}
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='arrow-left'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='arrow-right'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='calendar'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='camera'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='cart'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='chat-balloon'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='checked'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='clock'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='clone'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='dollar-sign'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-down'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-left'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-right'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-up'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='envelope'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='exclamation-mark'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='external'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='eye'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='heart'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='location'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='magnifier'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='order'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='pencil'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='printer'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='question-mark'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='refresh'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='settings'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='silhouette'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='tag'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='tools'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='trash-can'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='verified-price'
                    color='danger'
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph customClass='cursor-pointer' type='x' color='danger' />
                </Row>
              </Col>
              <Col xs={2}>
                <p>Ícones desabilitados</p>
                <Row className='glyphs-showcase'>
                  <img
                    src={DownloadDisabled}
                    width={48}
                    height={48}
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='arrow-left'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='arrow-right'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='calendar'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='camera'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='cart'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='chat-balloon'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='checked'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='clock'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='clone'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='dollar-sign'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-down'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-left'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-right'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='double-arrow-up'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='envelope'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='exclamation-mark'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='external'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='eye'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='heart'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='location'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='magnifier'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='order'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='pencil'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='printer'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='question-mark'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='refresh'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='settings'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='silhouette'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='tag'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='tools'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='trash-can'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='verified-price'
                    color='primary'
                    disabled
                  />
                </Row>
                <Row className='glyphs-showcase'>
                  <Glyph
                    customClass='cursor-pointer'
                    type='x'
                    color='primary'
                    disabled
                  />
                </Row>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Textos clicáveis</h4>
            <Row>
              <Col xs={6}>
                <TextLink text='Texto clicável' />
              </Col>
              <Col xs={6}>
                <TextLink isNotClickable text='Texto não-clicável' />
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <h4>Editor de HTML</h4>
            <Row>
              <Col xs={4}>
                <div className='w-100'>
                  <span className='input-container-label'>
                    Notas de atualização
                  </span>
                  <Editor placeholder={'Digite um texto aqui'} />
                </div>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <Row>
              <Col xs={2}>
                <div className='w-100 text-align-center'>Seta Verde para Cima Sem Valor</div>
                <div className='text-align-center'> <ArrowUpGreen   /></div>

              </Col>
              <Col xs={2}>
                <div className='w-100 text-align-center'>Seta Verde para Cima Com Valor </div>

                <div className='text-align-center'> <ArrowUpGreen value={"63"} /></div>
              </Col>

              <Col xs={2}>
              <div className='w-100 text-align-center'>Versão maior </div>
                <div className='text-align-center'> <ArrowUpGreen lineHeight={22} fontSize={18} value={"70"} />
              </div>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
            <Row>
              <Col xs={2}>
                <div className='w-100 text-align-center'>Seta Vermelha para Baixo Sem Valor</div>
                <div className='text-align-center'>   <ArrownDownRed /> </div>

              </Col>

              <Col xs={2}>
                <div className='w-100 text-align-center'>Seta Vermelha para Baixo Com Valor</div>
                <div className='text-align-center'> <ArrownDownRed value={"20,5"} /></div>
              </Col>

              <Col xs={2}>
                <div className='w-100 text-align-center'>Versão maior</div>
                <div className='text-align-center'> <ArrownDownRed lineHeight={22} fontSize={18} value={"50"} /></div>
              </Col>
            </Row>
          </div>

          <div className='show-case'>
              <div className='w-100 text-align-center'>Gráfico de Pizza</div>
              <Button
              style={{margin: '10px auto'}}
              disabled={this.state.loopInterval != null}
              className='btn-sm btn-primary margin-right flex'
              text='Clique aqui para ver em funcionamento'
              onClick={() => this.showPieBarUpdating()}
            />
              <MyResponsivePie data={this.state.data} />
          </div>
        </div>
      </>
    )
  }
}

const ComponentShowCaseTranslated = connect()(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    ComponentShowCase
  )
)

export default connect()(ComponentShowCaseTranslated)
